import { useNavigate } from "react-router-dom";
import { ChevronDown, FileText, Heart, LogOut, ShieldCheck, UserRound } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Avatar } from "./Bits";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";

export const ACCOUNT_LINKS = [
  { to: "/dashboard", label: "My proposals", Icon: FileText, id: "dashboard" },
  { to: "/dashboard/likes", label: "Proposals I like", Icon: Heart, id: "likes" },
  { to: "/dashboard/profile", label: "Profile and account", Icon: UserRound, id: "profile" },
];

/** Signs out from anywhere: go home first so protected pages don't flash their sign-in redirect. */
export const useSignOut = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return async () => {
    navigate("/");
    await logout();
  };
};

const itemStyle = { display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", fontSize: 15, fontWeight: 500, color: "var(--ink-2)", cursor: "pointer", borderRadius: 8 };

export const AccountMenu = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const signOut = useSignOut();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label={`Account menu for ${user.public_name}`} data-testid="header-account-menu-btn"
          style={{ display: "inline-flex", alignItems: "center", gap: 10, border: "1px solid transparent", background: "transparent", color: "#14232a", fontWeight: 600,
            fontSize: 15, minHeight: 44, padding: "0 8px 0 4px", borderRadius: 999, cursor: "pointer", font: "600 15px Inter, sans-serif" }}>
          <Avatar text={user.initials} />{user.public_name}<ChevronDown size={16} aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} style={{ width: 248, padding: 8, borderRadius: 14, boxShadow: "0 12px 32px rgba(20,35,42,.16)" }} data-testid="account-menu">
        <DropdownMenuLabel style={{ padding: "8px 12px 10px" }}>
          <span style={{ display: "block", fontSize: 15, fontWeight: 700, color: "var(--ink)" }}>{user.public_name}</span>
          <span style={{ display: "block", fontSize: 13, fontWeight: 400, color: "var(--muted)" }}>{user.role === "admin" ? "Admin · also a member" : "Member"}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {ACCOUNT_LINKS.map(({ to, label, Icon, id }) => (
          <DropdownMenuItem key={to} style={itemStyle} onSelect={() => navigate(to)} data-testid={`account-menu-${id}`}><Icon size={18} />{label}</DropdownMenuItem>
        ))}
        {user.role === "admin" && (
          <DropdownMenuItem style={{ ...itemStyle, color: "#C8102E", fontWeight: 600 }} onSelect={() => navigate("/admin")} data-testid="account-menu-admin"><ShieldCheck size={18} />Admin panel</DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem style={{ ...itemStyle, color: "var(--muted)" }} onSelect={signOut} data-testid="account-menu-signout"><LogOut size={18} />Sign out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
